// HEATCAST AI 학습/수요예측/감축 시뮬레이션 결과
// DR 감축·열버퍼·CBL 수치는 화면 시연을 위한 가상 예시이며 실제 분석 결과가 아님

export const HEATCAST_STORAGE_KEY = 'nexa_heatcast_results';

export const HEATCAST_NUMBER_KEYS = [
  'nmae', 'nrmse', 'rmse_kw', 'r2', 'avg_cut_kw', 'bid_kw', 'duration_h',
  'compliance_pct', 'margin_pct', 'fail_pct', 'rebound_kwh', 'buffer_kwh',
];

// 입력 형식 확인용 예시
export const HEATCAST_EXAMPLE = {
  engine: 'HDD 2차 다항회귀',
  split: '75 : 25',
  nmae: 8.4,
  nrmse: 11.2,
  rmse_kw: 2.6,
  r2: 0.91,
  avg_cut_kw: 18.5,
  bid_kw: 15.7,
  duration_h: 2.0,
  compliance_pct: 97.2,
  margin_pct: 15,
  fail_pct: 2.8,
  rebound_kwh: 6.4,
  buffer_kwh: 41.0,
  cbl: '온도보정 회귀',
  cbl_kw: 67.7,
  engines: [
    { name: 'HDD 2차 다항회귀', nmae: 8.4, nrmse: 11.2, r2: 0.91 },
    { name: 'SUNNYCAST 통계보정', nmae: 7.8, nrmse: 10.7, r2: 0.93 },
    { name: 'Random Forest 25 Trees', nmae: 7.1, nrmse: 9.8, r2: 0.95 },
  ],
  series: {
    labels: ['00', '02', '04', '06', '08', '10', '12', '14', '16', '18', '20', '22'],
    actual: [44, 41, 40, 47, 59, 66, 70, 65, 62, 72, 69, 54],
    predicted: [45, 42, 41, 46, 57, 64, 69, 67, 61, 70, 67, 55],
  },
  dr: {
    labels: ['0', '15', '30', '45', '60', '75', '90', '105', '120'],
    baseline: [64, 66, 68, 67, 69, 70, 71, 68, 66],
    controlled: [64, 55, 50, 49, 50, 51, 53, 65, 69],
  },
};

// S6 P2H 시험데이터(2,880시간) 기반 학습 결과 - 마지막 25% 기간 홀드아웃
export const HEATCAST_MEASURED_RESULT = {
  engine: 'Random Forest 25 Trees',
  split: '2160 / 720 (시간순 75:25)',
  nmae: 7.07,
  nrmse: 18.01,
  rmse_kw: 2.13,
  r2: 0.9102,
  avg_cut_kw: 18.5,
  bid_kw: 15.7,
  duration_h: 2.0,
  compliance_pct: 97.2,
  margin_pct: 15,
  fail_pct: 2.8,
  rebound_kwh: 6.4,
  buffer_kwh: 41.0,
  cbl: '예시 CBL (가상 시뮬레이션)',
  cbl_kw: 67.7,
  engines: [
    { name: 'HDD 2차 회귀 + 기상·시간', nmae: 17.29, nrmse: 25.04, r2: 0.8262 },
    { name: 'Random Forest 25 Trees', nmae: 7.07, nrmse: 18.01, r2: 0.9102 },
  ],
  series: {
    labels: Array.from({ length: 24 }, (_, i) => `01-30 ${String(i).padStart(2, '0')}시`),
    actual: [25.6, 22.17, 24.12, 24.33, 23.33, 20.6, 19.24, 17.9, 10.41, 8.91, 9.09, 5.34, 5.21, 5.13, 4.98, 4.92, 5.3, 10.16, 12.03, 13.26, 12.71, 14.33, 12.51, 13.92],
    predicted: [24.95, 25.38, 25.38, 24.97, 23.02, 22.37, 19.49, 18.06, 11.07, 9.65, 8.71, 5.84, 5.0, 4.84, 4.84, 5.01, 5.21, 10.95, 11.37, 12.6, 14.5, 15.48, 14.47, 14.77],
  },
  dr: {
    labels: ['0', '15', '30', '45', '60', '75', '90', '105', '120'],
    baseline: [64, 66, 68, 67, 69, 70, 71, 68, 66],
    controlled: [64, 55, 50, 49, 50, 51, 53, 65, 69],
  },
};

export const HEATCAST_MEASURED_MESSAGE = {
  source: 'S6 P2H CSV 기반 학습 · 홀드아웃 검증',
  curve: 'S6 P2H 시험데이터 · 시간별 실측/예측(kW) · 시간순 홀드아웃 25%',
  dr: '감축 시뮬레이션 예시 · 가상 CBL / 감축 운전 부하(kW) · 실증값 아님',
};

export const HEATCAST_INPUT_MESSAGE = {
  source: '입력 결과 표시',
  curve: '시간별 부하 · kW',
  dr: 'CBL 기준 부하 / 감축 운전 부하 · kW',
};

export const HEATCAST_SERIES_COLOR = {
  ACTUAL: '#43b9ed',
  PREDICTED: '#f6c858',
};
